<template>
  <div class="bg-gray full-height">
    <div class="container-fluid">
      <div class="row" style="padding-top:20px;">
        <div class="col-sm-5 col-centered">
          <div class="white-panel" style="margin-bottom: 0px;">
            <h1>Reset Password</h1>
            <div class="row" style="margin-top:20px;" v-if="!success">
              <div class="col-xs-12 col-sm-12">
                <div v-if="!valid" class="alert alert-danger" role="alert">
                  Your reset password link is not valid
                </div>
                <div v-if="valid" class="form-group">
                  <input v-model="password" type="password" class="form-control" placeholder="Password">
                </div>
                <div v-if="valid" class="form-group">
                  <input v-model="passwordConfirmation" type="password" class="form-control" placeholder="Confirm Password">
                </div>
                <div v-if="passwordConfirmation.length > 1 && password != passwordConfirmation">
                  Passwords must match
                </div>
                <div v-if="valid" class="form-group">
                  <button v-on:click="resetPassword" style="width:100%;" class="btn btn-primary btn-blue">Reset Password</button>
                </div>
                <a class="blue" href="/account/forgotPassword">Forgot Password?</a>
              </div>
            </div>
            <div v-else >
              <div class="alert alert-success" role="alert">
                  Your password has been reset. You can now <a href="/account/login">log in</a>.
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from '@/components/nav/NavigationBar'
import API from '@/API/API'
import DashboardFooter from '@/components/nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'

export default {
  name: 'ResetPassword',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      api: API,
      nav: Navigator,
      password: '',
      passwordConfirmation:'',
      id:'',
      key:'',
      valid:true,
      success:false
    }
  },
  mounted () {
    if(!this.$route.params.id || !this.$route.params.key) {
      this.valid = false
    }else{
      this.id = this.$route.params.id
      this.key = this.$route.params.key
    }
  },
  methods: {
    resetPassword: function() {

      if(this.password == ''){
        this.$toasted.show('Password is required', { type: 'error', duration: 2500 })
        return
      }

      if(this.passwordConfirmation == ''){
        this.$toasted.show('Password Confirmation is required', { type: 'error', duration: 2500 })
        return
      }

      let self = this
      this.api.resetPassword(this.id, this.password, this.key)
      .then(function (res) {
        if("data" in res){
          let resData = res.data
          if("error" in resData){
            let error = resData.error
            self.$toasted.show(error, { type: 'error', duration: 2500 })
          }else{
            self.password = ''
            self.passwordConfirmation = ''
            self.success = true
          }
        }
      })
      .catch(e => {
        this.$toasted.show('Failed to reset password', { type: 'error', duration: 2500 })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/ResetPassword.vue